import React from "react";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import '../assets/styles/Main.scss';

function Main() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="hero-section">
      <div className="hero-inner">
        <div className="hero-left">
          <span className="hero-tag">{'// AWS Solutions Architect'}</span>
          <h1 className="hero-title">
            Cloud infrastructure<br />built to last.
          </h1>
          <p className="hero-subtitle">
            8+ years designing, optimizing, and operating AWS and Kubernetes
            environments across fintech, telecommunications, and cloud-native platforms.
            Based in Berlin, Germany.
          </p>
          <div className="hero-actions">
            <button className="btn-primary" onClick={() => scrollTo('portfolio')}>
              View My Work
            </button>
            <button className="btn-secondary" onClick={() => scrollTo('contact')}>
              Get In Touch
            </button>
          </div>
          <div className="hero-links">
            <a href="https://www.linkedin.com/in/ahmadrgharib" target="_blank" rel="noreferrer">
              <LinkedInIcon fontSize="small" /> LinkedIn
            </a>
            <a href="https://github.com/ahmadrgharib" target="_blank" rel="noreferrer">
              <GitHubIcon fontSize="small" /> GitHub
            </a>
            <a href="https://www.upwork.com/freelancers/~012aecb8a29fb8b721" target="_blank" rel="noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true" style={{ verticalAlign: 'middle', marginRight: '4px' }}>
                <path d="M18.375 9.556c-1.64 0-2.916.96-3.455 2.373l-1.234-5.04H11.25v6.416c0 1.013-.82 1.834-1.833 1.834s-1.834-.821-1.834-1.834V6.889H5.147v5.416c0 2.17 1.76 3.929 3.93 3.929 2.169 0 3.928-1.76 3.928-3.93v-.906c.48 1.61 1.88 2.836 3.37 2.836 2.17 0 3.93-1.76 3.93-3.929 0-2.17-1.76-3.75-1.93-3.75zm0 5.512c-.96 0-1.75-.79-1.75-1.762 0-.973.79-1.762 1.75-1.762.96 0 1.75.789 1.75 1.762 0 .972-.79 1.762-1.75 1.762z" />
              </svg>
              Upwork
            </a>
          </div>
          <div className="hero-stats">
            <div className="hero-stat">
              <span className="stat-value">8+</span>
              <span className="stat-label">Years</span>
            </div>
            <div className="stat-sep" />
            <div className="hero-stat">
              <span className="stat-value">5</span>
              <span className="stat-label">AWS Certs</span>
            </div>
            <div className="stat-sep" />
            <div className="hero-stat">
              <span className="stat-value">Multi</span>
              <span className="stat-label">Cloud & Region</span>
            </div>
            <div className="stat-sep" />
            <div className="hero-stat">
              <span className="stat-value">PCI</span>
              <span className="stat-label">DSS Experience</span>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-photo-frame">
            <img
              src={require('../assets/images/ahmad-linkedin.jpg')}
              alt="Ahmad Gharib"
              className="hero-photo"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
